const CONSTANTS = {
	AppDescriptor: 'PRODUCTS',

	FlowsUrls: {
		downloadDocuments: '/products-homepage/api/download-documents',
	},

	MinimumDaysToCheckForUpdates: 7,

	OtherDocuments: {
		subcategoryId: 44,
		categoryId: 10,
	},

	textareaAutosize: {
		minHeight: 30,
		maxHeight: 180,
	},

	UserManualUrl: (locale) => {
		switch (locale) {
			case 'es':
				return 'https://teams.microsoft.com/l/channel/19%3Ad2f48f2e101546fe88c90bac04edca8a%40thread.tacv2/tab%3A%3A2bfc2bfa-ad6d-4330-8250-7d433823d814?groupId=0a2f9a63-21b1-4291-b95d-09344d8c378e&tenantId=d22192b2-04da-46e5-b9f6-cf9af1c33077';
			case 'ca':
			default:
				return 'https://teams.microsoft.com/l/channel/19%3Ad2f48f2e101546fe88c90bac04edca8a%40thread.tacv2/tab%3A%3A2bfc2bfa-ad6d-4330-8250-7d433823d814?groupId=0a2f9a63-21b1-4291-b95d-09344d8c378e&tenantId=d22192b2-04da-46e5-b9f6-cf9af1c33077';
		}
	},

	UserSettings: {
		localStorageKey: 'Products.userSettings',
		fieldsKeys: {
			copyLinkToClipboard: 'copyLinkToClipboard',
			documentLinksFilter: 'documentLinksFilter',
			downloadDocuments: 'downloadDocuments',
			editDocumentLink: 'editDocumentLink',
			editUserNoteComment: 'editUserNoteComment',
			familySettings: 'familySettings',
			favorite: 'favorite',
			filtersLanguage: 'filtersLanguage',
			filtersSubcategory: 'filtersSubcategory',
			generalFilters: 'generalFilters',
			openPDF: 'openPDF',
			openSeries: 'openSeries',
			releaseNotes: 'releaseNotes',
			showHistoryVersion: 'showHistoryVersion',
			usageTracker: 'usageTracker',
		},
	},
};

export { CONSTANTS };
